$(function(){
    var moveHeight = 400,
        moveTime = 200,
        curMove = null;
    $('.series-item li').hover(function(e){
        var curLi = $(this);
        curMove = setTimeout(function(){
            curLi.children('div.div1').animate({top: '-' + moveHeight + 'px'}, moveTime);
            curLi.children('div.div2').animate({top: '0px' },moveTime)
        },200)
    },function(e){
        clearTimeout(curMove);
        $(this).children('div.div1').animate({top: '0px'},moveTime);
        $(this).children('div.div2').animate({top: moveHeight + 'px'},moveTime)
    })
});


/** jQuery Swiper - Lionad 
 * @var config.target 要转换的swiper (DOM或ID/class)
 * @var config.item swiper的子项
*/
(function ($) {
    $.swiperInit = function (config) {
        
        /* Init Config */

        // implement config
        config = $.extend({
            counts: 3,
            item: 'item',
            sizes: null,
            force: 10,
            log: false,
            animeTime: '.4s',
            tickTime: 2000,
        }, config)
        // check config key:values
        if (!(config.counts % 2)) {
            config.counts -= 1
        }
        config.log && console.log(config)

        /* Init Handle */

        // init swiper && swiper items
        let $swiper, 
            $swiperItem,
            itemLen,
            midLen
        let offset = 0,
            pause = false,
            goLeft = () => pause || offset --,
            goRight = () => pause || offset ++
        let calcHandle = () => {
            if (config.target instanceof Object) {
                $swiper = config.target
            } else if (config.target.length) {
                $swiper = $(config.target)
            }
            $swiperItem = $swiper.find(config.item)
        }
        calcHandle()
        itemLen = $swiperItem.length
        midLen = Math.floor(itemLen / 2)
        config.log && console.log('ItemLen|midLen: ', itemLen, midLen)
        config.log && console.log('swiperItem :', $swiperItem)
        // init styles
        $.each($swiperItem, (index, item) => {
            let $item = $(item)
                $item.css({
                    'position': 'absolute',
                    'display': 'inline-block',
                    'top': 0,
                    'left': 0,
                    'transition': config.animeTime,
                    'transform': 'translateX(-50%)',
                    'will-change': 'transform',
                })
                $item.find('img').css({
                    'transition': config.animeTime,
                    'will-change': 'width height',
                })
        })

        /* Calc Styles */

        let width = $swiper.width(),
            height = $swiper.height(),
            midWidth = width / 2,
            partWidth = width / config.counts,
            positionX = [],
            positionY = [],
            positionUnPushed = config.counts
        // calc positionY
        let calcPositionY = () => {
            Array.apply(undefined, { length: config.counts }).map((x, i) => {
                positionY.push(
                    (config.sizes[midLen].h - config.sizes[i].h) / 2
                )
            })
        }
        // calc positionX
        let calcPositionX = () => {
            while (positionUnPushed > 0) {
                let index = (config.counts - positionUnPushed),
                    absLen = Math.abs(midLen - index)
                    positionUnPushed --
                if (index < midLen) {
                    let add = 0,
                        inc =  partWidth * absLen
                    if (config.sizes) {
                        for (let i=index; i<midLen; i++) {
                            add += config.sizes[i].w
                        }
                        inc = add
                    }
                    positionX.push(midWidth - inc + config.force * absLen)
                } else if (index == midLen) {
                    positionX.push(midWidth)
                } else if (index > midLen) {
                    let add = 0,
                        inc =  partWidth * absLen
                    if (config.sizes) {
                        for (let i=index; i>midLen; i--) {
                            add += config.sizes[i].w
                        }
                        inc = add
                    }
                    positionX.push(midWidth + inc - config.force * absLen)
                }
            }
        }
        let calcPosition = () => {
            positionX = []
            positionY = []
            positionUnPushed = config.counts
            calcPositionY()
            calcPositionX()
        }
        let realIndex = (index) => {
            let raw = (index + offset) % itemLen
            if (raw < 0) {
                raw = itemLen + raw
            }
            return raw
        }
        calcPosition()
        config.log && console.log('Position Array :', positionX)

        /* Set Styles */

        // set swiper style
        // $swiper.css('position') == 'inherit' &&
        $swiper.css({
            'position': 'relative',
            'z-index': 1,
        })
        // set swiper item style
        let setPosition = () => {
            $.each($swiperItem, (index, item) => {
                let $item = $(item),
                    rindex = realIndex(index)
                $item.css({
                    'top': positionY[rindex],
                    'left': positionX[rindex],
                    'z-index': ''+(-Math.abs(midLen - rindex)+midLen),
                })
                $item.find('img').css({
                    'width': config.sizes[rindex].w + 'px',
                    'height': config.sizes[rindex].h + 'px',
                })
            })
        }
        setPosition()

        /* Move */

        $.each($swiperItem, (index, item) => {
            $(item).hover(function () {
                pause = true
            }, function () {
                pause = false
            })
        })

        let tick = setInterval(() => {
            pause || goRight()
            setPosition()
        }, config.tickTime)

        // this.clear = clearInterval(tick)

        // return this
    }
})(jQuery)

let $swiper = $('#swiper-container')
let swiper = $.swiperInit({
    target: $swiper,
    item: '.swiper-box',
    force: -20,
    counts: 5,
    sizes: [
        {w: 172, h: 287}, 
        {w: 217, h: 387}, 
        {w: 260, h: 436}, 
        {w: 217, h: 387}, 
        {w: 172, h: 287}
    ],
})

var $bannerSwiper = new Swiper('#banner-swiper-container', {
    loop: true,
    autoplay: 3000,
})


/* Animation */
/*********************************************/

let $bubbleBlock = $('.bubble-block'),
    $circleBlock = $('.circle-block'),
    $pptBlock = $('.ppt-block'),
    $solveBlock = $('.solve-block')
const trigger = {
    'bubble-pop': {
        handle: $bubbleBlock.find('.bubble'),
        height: 280,
    },
    'bubble-arrow': {
        handle: $bubbleBlock.find('.arrow'),
        height: 480,
    },
    'bubble-plan': {
        handle: $bubbleBlock.find('.plan'),
        height: 680,
    },
    'circle-2': {
        handle: $circleBlock.find('.circle.index-2'),
        height: 1280,
    },
    'circle-1': {
        handle: $circleBlock.find('.circle.index-1'),
        height: 1380,
    },
    'circle-3': {
        handle: $circleBlock.find('.circle.index-3'),
        height: 1650,
    },
    'ppt': {
        handle: $pptBlock.find('.img-con'),
        height: 3200,
    },
    'solve': {
        handle: $solveBlock.find('.solve'),
        height: 5080,
    },
}
let $window = $(window)
let deviceBenefit = Math.pow(Math.floor(Math.sqrt(window.screen.height) / (window.screen.width / window.screen.height)), 2) / 12
let calcTime = (time = '.5') => {
    time = +time
    let offset = Math.random() * time
    
    return ''+(time+offset)+'s'
}
let handleScroll = () => {
    // 兼容IE的方法
    let wh = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
    for (let key in trigger) {
        let cTrigger = trigger[key]
        if (!cTrigger.done && cTrigger.height < wh + deviceBenefit) {
            $.each(cTrigger.handle, (index, item) => {
                $(item).css({
                    'transition': calcTime(cTrigger.time),
                })
                $(item).addClass(cTrigger.class || 'active')
            })
            cTrigger.done = true
        }
    }
}
$window.scroll(function () {
    handleScroll()
})
handleScroll()

$('#page-gustomer').addClass('active')